import { AddIcon } from "@chakra-ui/icons";
import { Button, Flex } from "@chakra-ui/react";
import { GetLayout } from "components/get-layout";
import { GridServers } from "components/sessoes-whatsapp-components/grid-servers";
import { openModalAddWhatsAppServer } from "components/sessoes-whatsapp-components/grid-servers/add-whatsapp-server-modal";
import { useState } from "react";
import { RoutePermissionFunction } from "router-manager/parts";

export default function SessoesWhatsApp() {
  const [loading, setLoading] = useState(true);
  return (
    <GetLayout
      title="Sessões WhatsApp"
      rightContent={
        <Button
          disabled={loading}
          onClick={() => openModalAddWhatsAppServer()}
          leftIcon={<AddIcon />}
        >
          Criar Sessão
        </Button>
      }
    >
      <GridServers loading={loading} setLoading={setLoading} />
    </GetLayout>
  );
}

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.setUserTypesPermission([
    "SUPER",
    "REGIONAL",
    "COMERCIAL",
    "PARCEIRO_GERENTE_ESTRATEGICO",
    "PARCEIRO_GERENTE_VAREJO",
    "PARCEIRO_MASTER",
    "ASCOM"
  ]);
  route.setColomboUserTypesPermission([
    "COMERCIAL",
    "PARCEIRO_GERENTE_ESTRATEGICO",
    "PARCEIRO_GERENTE_VAREJO"
  ]);
};
